import { render, staticRenderFns } from "./goodsAttr.vue?vue&type=template&id=20f8a7e8&scoped=true&"
import script from "./goodsAttr.vue?vue&type=script&lang=js&"
export * from "./goodsAttr.vue?vue&type=script&lang=js&"
import style0 from "./goodsAttr.vue?vue&type=style&index=0&id=20f8a7e8&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f8a7e8",
  null
  
)

export default component.exports